import { frontendURL } from 'dashboard/helper/URLHelper';
import ProductsView from './ProductsView.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/products'),
    name: 'products_view',
    meta: {
      permissions: ['administrator', 'agent'],
    },
    component: ProductsView,
  },
];
